import React from 'react';

function Home() {
    return (
        <div>
            <h1>App is up and running</h1>
        </div>
    );
}

export default Home;
